const ApiURL = {
  _appVersions: "v1/member/app-versions",
  _login: "v1/member/login",
  _logout: "v1/member/logout",
  _signup: "v1/member/sign-up",
  _facebookSignupLogin: "v1/member/facebook-signup-login",
  _appleSignupLogin: "v1/member/apple-signup-login",
  _accessTokenLogin: "v1/member/access-token-login",
  _updateProfile: "v1/member/update-profile",
  _resendVerifyEmail: "v1/member/resend-verify-email",
  _forgotPassword: "v1/member/forgot-password",
  _changePWD: "/v1/member/verify-old-reset-new-password",
  _deleteAccount: "/v1/user/authorize-deletion",
  _gymInfo: "v1/member/gym-info",
  _gymLocationList: "v2/member/list-gym-locations",
  _linkGym: "v1/member/link-gym",
  _updateGymWaiver: "v1/member/update-gym-waiver",
  _updateGymLocations: "/v1/member/update-gym-location",
  _updateDefaultGym: "/v1/member/update-default-gym",

  _clearAllNotifications: "/v1/member/clear-notifications",
  _listNotifications: "/v1/member/list-notifications",
  _readNotification: "/v1/member/read-notification",

  _recommendedOndemandActivities:
    "/v1/member/web/list-recommended-ondemand-activities",
  _ondemandActivities: "v1/member/web/list-ondemand-activities",
  _newOndemandActivities: "v1/member/web/list-new-ondemand-activities",
  _listUpcomingActivities: "v1/member/list-upcoming-activities",
  _listBookedActivities: "v1/member/list-booked-activity",
  _listLiveAndUpcomingActivities: "/v1/member/list-upcoming-activities",
  _listCategories: "/v1/member/list-gym-categories",
  _listSections: "/v1/member/list-dashboard-sections",
  _listDashboardActivities: "/v1/member/dashboard-list-activities",
  _listActivitesForCategory: "/v1/member/list-activity-for-specific-category",
  _upcomingActivityInfo: "/v1/member/upcoming-activity-info",
  _ondemandActivityInfo: "/v1/member/list-activity-attempts",
  _bookScheduledActivity: "/v1/member/book-scheduled-activity",
  _cancelBookedActivity: "/v1/member/cancel-booked-activity",
  _cancelGymRequest: "/v1/member/cancel-gym-link-request",
  _ondemandActivity: "/v1/activity/start-ondemand",
  _endOndemand: "/v1/activity/end-ondemand",
  _joinActivityV3: "v3/member/join-activity",
  _syncActivity: "v1/activity/sync",
  _beforeStartMyVideo: "/v1/activity/start-participant-video",
  _leaveActivity: "/v1/member/leave-activity",
  _classSummary: "/v1/member/activity-summary",
  _coachesList: "/v1/member/web/list-coaches",
  _coachProfileData: "/v1/member/web/view-coach-profile",

  _listActivities: "/v1/member/list-activities",
}

export default ApiURL
